// extracted by mini-css-extract-plugin
export default {"loading":"LoadingFullScreen_loading__cTFsI"};